export var addInputErrorAriaProps = function addInputErrorAriaProps(errorText, errorId, restProps) {
  var extraDescribedBy = restProps['aria-describedby'];
  var ariaDescribedBy;

  if (errorText) {
    ariaDescribedBy = extraDescribedBy ? "".concat(errorId, "-error-text ").concat(extraDescribedBy) : "".concat(errorId, "-error-text");
  } else {
    ariaDescribedBy = extraDescribedBy || undefined;
  }

  return {
    'aria-describedby': ariaDescribedBy,
    'aria-invalid': errorText ? 'true' : undefined
  };
};